import {observer} from 'mobx-react';
import React from 'react';

import {Button, ButtonProps} from '@udemy/react-core-components';
import {useUDData} from '@udemy/ud-data';

interface EnableCouponInputModeButtonProps {
    onClick: () => void;
    buttonProps: ButtonProps;
}

export const EnableCouponInputModeButton: React.FC<EnableCouponInputModeButtonProps> = observer(
    ({onClick, buttonProps}) => {
        const udData = useUDData();

        return !udData.Config.brand.has_organization ? (
            <Button
                type="submit"
                onClick={onClick}
                size="medium"
                udStyle="secondary"
                {...buttonProps}
            >
                {gettext('Apply Coupon')}
            </Button>
        ) : null;
    },
);
